var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.url)?_c('img',{staticClass:"rounded-full",class:_vm.customClass,attrs:{"src":_vm.url,"alt":""}}):_c('Avatar',{class:_vm.customClass,attrs:{"name":_vm.alt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }